"use server";

import { AuthError } from "next-auth";
import { signIn } from "@/auth";

/** Next.js signals redirects by throwing an error carrying a NEXT_REDIRECT digest. */
function isRedirect(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "digest" in error &&
    typeof (error as { digest?: unknown }).digest === "string" &&
    (error as { digest: string }).digest.startsWith("NEXT_REDIRECT")
  );
}

export async function login(
  _prev: string | undefined,
  formData: FormData,
): Promise<string | undefined> {
  try {
    await signIn("credentials", {
      email: formData.get("email"),
      password: formData.get("password"),
      redirectTo: "/",
    });
  } catch (error) {
    // signIn throws a redirect on success — let Next handle it.
    if (isRedirect(error)) throw error;
    if (error instanceof AuthError) return "Virheellinen sähköposti tai salasana";
    throw error;
  }
  return undefined;
}
